export default function SortMenu({ sort, setSort }) {
  return (
    <select
      value={sort}
      onChange={(e) => setSort(e.target.value)}
      className="px-3 py-2 border rounded-lg"
    >
      <option value="">Sort</option>
      <option value="low">Price: Low to High</option>
      <option value="high">Price: High to Low</option>
      <option value="discount">Top Discount</option>
    </select>
  );
}
